module.exports = __webpack_public_path__ + "resources/img/logo_partner_public_nipa_m.7d3546d8a7a82d9e8df77531a1aecbdd.png";